<template>
  <yiban-tool :flow="flow"> </yiban-tool>
</template>
<script>
import yibanTool from "./yibanTool.vue";
export default {
  components: { yibanTool },
  data() {
    return {
      flow: {
          id: "1611273939011809286",
          name: "日常保洁",
          name1: "保洁待办处理",
        },
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/yhgl/yibanchuli.vue